import { observer } from 'mobx-react';
import * as React from 'react';
import Select, { Props } from 'react-select';

// I can't import 'react-select' normally in a TS component. If I do
//
//    import Select from 'react-select';
//
// It works in a .js file but breaks in a .ts file at runtime, with this error:
//
//    Uncaught Invariant Violation: Element type is invalid: expected a string (for built-in
//    components) or a class/function (for composite components) but got: undefined
//
// I finally realized that if I do `import * as Select from 'react-select'` it works at runtime, but
// the types don't think it should work.
//
// This forces the types to accept that, and lets other TS files import the result more easily from
// here.
//
// Also, `import { Async } from 'react-select'` works fine.

@observer
class SelectForTS<TValue> extends React.Component<Props<TValue>> {
  render() {
    const SelectForTS = Select as unknown as React.ComponentType<Props<TValue>>;

    return <SelectForTS {...this.props} />;
  }
}

export default SelectForTS;
